import { useEffect, useState } from "react";
import { motion } from "framer-motion";
import axios from "axios";

const BACKEND = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND}/api`;

const STOCK = [
  { url: "https://images.unsplash.com/photo-1560272564-c83b66b1ad12?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "First touch" },
  { url: "https://images.unsplash.com/photo-1637430308606-86576d8fef3c?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "The floor" },
  { url: "https://images.unsplash.com/photo-1508087625439-de3978963553?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Match pace" },
  { url: "https://images.unsplash.com/photo-1672344048213-76b6e77304bd?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Load & lift" },
  { url: "https://images.unsplash.com/photo-1624280157150-4d1ed8632989?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Game day" },
  { url: "https://images.unsplash.com/photo-1676655079738-af54dfd6318e?crop=entropy&cs=srgb&fm=jpg&q=85&w=1200", caption: "Conditioning" },
];

const rise = {
  hidden: { opacity: 0, y: 50 },
  visible: (i) => ({ opacity: 1, y: 0, transition: { duration: 0.8, delay: (i % 6) * 0.08, ease: [0.22, 1, 0.36, 1] } }),
};

export default function Gallery() {
  const [images, setImages] = useState(STOCK);

  useEffect(() => {
    axios
      .get(`${API}/gallery`)
      .then((r) => {
        if (r.data.images && r.data.images.length > 0) {
          setImages(r.data.images.map((i) => ({ url: `${BACKEND}${i.url}`, caption: i.caption })));
        }
      })
      .catch(() => {});
  }, []);

  return (
    <section id="gallery" data-testid="gallery" className="max-w-[1400px] mx-auto px-6 md:px-10 py-24 md:py-40">
      <motion.div
        initial={{ opacity: 0, y: 40 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="mb-14 md:mb-20 max-w-2xl"
      >
        <span className="text-[#2E6BE6] text-xs uppercase tracking-[0.3em]">Gallery</span>
        <h2 className="font-display font-bold uppercase tracking-tighter text-4xl md:text-6xl mt-4 leading-[0.95]">
          Where the work happens.
        </h2>
      </motion.div>

      <div className="grid grid-cols-2 md:grid-cols-3 gap-3 md:gap-4">
        {images.map((img, i) => (
          <motion.figure
            key={i}
            custom={i}
            variants={rise}
            initial="hidden"
            whileInView="visible"
            viewport={{ once: true, amount: 0.2 }}
            className={`group relative overflow-hidden border border-white/10 ${
              i % 5 === 0 ? "row-span-2 aspect-[3/4]" : "aspect-square"
            }`}
            data-testid={`gallery-item-${i}`}
          >
            <img
              src={img.url}
              alt={img.caption || "gallery"}
              className="w-full h-full object-cover object-top transition-transform duration-[900ms] ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[#2E6BE6] mix-blend-color opacity-30 pointer-events-none" />
            <div className="absolute inset-0 bg-black/20 group-hover:bg-black/0 transition-colors" />
            {img.caption && (
              <figcaption className="absolute bottom-3 left-3 text-xs uppercase tracking-[0.2em] text-white/0 group-hover:text-white translate-y-2 group-hover:translate-y-0 transition-all duration-500">
                <span className="text-[#D4AF37]">/</span> {img.caption}
              </figcaption>
            )}
          </motion.figure>
        ))}
      </div>
    </section>
  );
}
